import { Badge, type BadgeProps } from '@fluentui/react-components';

type FluentBadgeColor = NonNullable<BadgeProps['color']>;

interface Props<T extends string> {
  /** Valor de dominio a mostrar (ej. ModuleStatus, ActivityType) */
  value: T;
  /** Texto ya traducido a mostrar en el badge */
  label: string;
  /** Mapa valor de dominio → color de Fluent Badge, definido una vez por dominio */
  colorMap: Record<T, FluentBadgeColor>;
  size?: BadgeProps['size'];
  appearance?: BadgeProps['appearance'];
}

/**
 * Wrapper delgado sobre Badge de Fluent que centraliza el patrón
 * `<Badge color={MAP[value]}>{label}</Badge>` repetido en cada página
 * (ver STATUS_BADGE en InvestorModulesPage, TYPE_COLOR en ActivityFeed).
 * El mapeo de colores sigue siendo responsabilidad del caller — este
 * componente solo evita reescribir el fallback y el spread de props.
 */
export function StatusBadge<T extends string>({ value, label, colorMap, size, appearance = 'tint' }: Props<T>) {
  return (
    <Badge color={colorMap[value] ?? 'informative'} appearance={appearance} size={size}>
      {label}
    </Badge>
  );
}
